import { useState, useEffect } from "react";

function Plan({ title, subTitle, slides, bgColor, id }) {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);
  const [openIndex, setOpenIndex] = useState(0); // Garante que o primeiro sempre estará aberto

  useEffect(() => {
    const updateImage = () => setIsMobile(window.innerWidth < 1024);
    window.addEventListener("resize", updateImage);
    return () => window.removeEventListener("resize", updateImage);
  }, []);

  return (
    <section className={`tc-plan ${bgColor ? bgColor : ""}`}>
      <div className="container">
        <div className="title mb-120">
          <div className="row justify-content-between">
            <div className="d-flex col-lg-12 flex-wrap plan-header">
              <h2
                className={`${
                  bgColor === "plan-bg-white" ? "color-brown2" : "text-white "
                } fsz-65 text-uppercase js-splittext-lines font-palast-regular ltspc-20`}
              >
                {title}
              </h2>
              <span className="fsz-24 color-gray2 ms-50 text-uppercase align-self-end ltspc-12 wow zoomIn slow">
                {subTitle}
              </span>
              <button
                onClick={() => window.openModal()}
                className="butn border rounded-pill border-brown1 hover-bg-brown1 text-uppercase color-brown1 mt-20 ms-auto wow zoomIn slow"
              >
                <span className="ltspc-1"> Quero saber mais </span>
              </button>
            </div>
          </div>
        </div>
        <div className="plan wow zoomIn slow" data-wow-delay="0.2s">
          <div className="flex-accordion">
            <ul className="acc-list">
              {slides.map((item, i) => (
                <li
                  key={id + i}
                  className={`acc-li ${openIndex === i ? "is-open" : ""}`}
                  onClick={(e) => {
                    e.stopPropagation();
                    setOpenIndex(i);
                  }}
                >
                  <img
                    src={isMobile ? item.imgMob : item.img}
                    alt=""
                    className="bg img-cover"
                    loading="lazy"
                  />

                  <div className="panel-inner">
                    <div className="acc-title fw-600">
                      <div className="txt txt-title ltspc-4">
                        {item.subTitle}
                      </div>
                      <div className="txt-subtitle ltspc-4">
                        <i className="icon fas fa-hand-pointer fa-2x"></i>
                        {item.title}
                      </div>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Plan;
